import { mergeAttributes } from '@tiptap/core'
import Mention from '@tiptap/extension-mention'

const MARKDOWN_SPECIAL_CHARACTERS = /[*_`~[\]\\<>&]/g

export const BotObject = Mention.extend({
  name: 'botObject',

  addOptions() {
    const parent = this.parent?.() ?? {}

    return {
      ...parent,
      pickerUrl: null,
      suggestion: {
        ...parent.suggestion,
        char: '@',
        command: ({ editor, range, props }) => {
          editor
            .chain()
            .focus()
            .insertContentAt(range, [
              {
                type: 'botObject',
                attrs: {
                  gid: props.gid,
                  label: props.label?.replace(MARKDOWN_SPECIAL_CHARACTERS, ''),
                },
              },
              { type: 'text', text: ' \u200B' },
            ])
            .run()
        },
      },
    }
  },

  addAttributes() {
    return {
      gid: {
        default: null,
        parseHTML: (element) => element.getAttribute('data-gid'),
        renderHTML: (attributes) =>
          attributes.gid ? { 'data-gid': attributes.gid } : {},
      },
      label: {
        default: '',
        parseHTML: (element) => element.textContent,
        renderHTML: () => ({}),
      },
    }
  },

  parseHTML() {
    return [{ tag: 'span.bot-object[data-gid]' }]
  },

  renderText({ node }) {
    return node.attrs.label
  },

  renderHTML({ node, HTMLAttributes }) {
    return [
      'span',
      mergeAttributes(this.options.HTMLAttributes, HTMLAttributes),
      node.attrs.label,
    ]
  },
}).configure({
  HTMLAttributes: {
    class: 'bot-object',
  },
})
